import { get } from 'lodash';

import { getAnalyticsSection } from './getAnalyticsSection';

import Locations from 'apps/basket/models/Locations';

const getUserFilters = (analyticsContextData) => {
  const filters = get(analyticsContextData, 'productsPageRouteLocationQuery.filters', undefined);
  return (filters ? filters.split(',') : undefined);
};

const getSearch = (analyticsContextData) =>
  get(analyticsContextData, 'productsPageRouteLocationQuery.entry', undefined);

const generateMandatoryStats = (basketUpdateResponse) => ({
  addedFromUrl: window.location.href,
  basketPriceChange: get(basketUpdateResponse, 'analyticsData.basketValueChange', undefined),
  price: get(basketUpdateResponse, 'price', 0),
  sku: get(basketUpdateResponse, 'sku', 'no SKU'),
  totalQuantity: get(basketUpdateResponse, 'analyticsData.newTotalQuantity', undefined),
  updatedQuantity: get(basketUpdateResponse, 'analyticsData.quantityChange', undefined),
});

const getPageType = (section, pageType) => {
  const sectionType = get(section, 'attributes.type');
  if (sectionType === 'MINI_TROLLEY') return 'NA';
  if (sectionType === 'TROLLEY') return Locations.TROLLEY_SIDEBAR;
  return pageType;
};

const generateNonMandatoryStats = (basketUpdateResponse, analyticsContextData, pageType) => ({
  pageType: getPageType(analyticsContextData.section, pageType),
  section: getAnalyticsSection({
    pageType,
    sectionAttributesType: get(analyticsContextData, 'section.attributes.type'),
    containerType: get(analyticsContextData, 'containerType'),
  }),
  updateFunction: get(analyticsContextData, 'updateFunction', undefined),
  userFilters: getUserFilters(analyticsContextData),
  searchInputMechanism: (getSearch(analyticsContextData) ? 'WEBSITE_SEARCH' : undefined),
  searchTerm: getSearch(analyticsContextData),
  pageComponentId: `${get(analyticsContextData, 'section.id')}.${basketUpdateResponse.sku}`,
  promoId: get(basketUpdateResponse, 'offerId', undefined),
});

export function generateWaBasketQuantityUpdate(basketUpdateResponse, analyticsContextData, pageType) {
  if (basketUpdateResponse === false) {
    return false;
  }
  const response = { bqus: [] };
  basketUpdateResponse.forEach((successfulUpdate) => {
    response.bqus.push({
      mandatoryFields: generateMandatoryStats(successfulUpdate),
      nonMandatoryFields: generateNonMandatoryStats(successfulUpdate, analyticsContextData, pageType),
    });
  });
  return response;
}

export const generateLocationRelatedData = (productsPageRoute) => ({
  entry: get(productsPageRoute, 'location.query.entry'),
  filters: get(productsPageRoute, 'deslugifiedQuery.filters'),
});
